<ng-container rtBlock="sc-contact-form">
    @if (!hideEditorial()) {
        <div rtElem="editorial">
            <div rtElem="editorial-eyebrow">
                <span rtElem="editorial-dot" aria-hidden="true"></span>
                <span rtElem="editorial-tag" i18n="@@homeContactEyebrow">Связаться со студией</span>
            </div>
            <h3 rtElem="editorial-h3">
                <span i18n="@@homeContactH3A">Расскажите</span>
                &ngsp;
                <em i18n="@@homeContactH3Em">о задаче —</em>
                <br />
                <span i18n="@@homeContactH3B">ответим в течение суток.</span>
            </h3>
            <p rtElem="editorial-p" i18n="@@homeContactLede">
                Если конструктор не покрывает вашу геометрию, нужен выезд замерщика, нестандартное сечение тетивы или совет по породе под
                бюджет — напишите. Форма уходит напрямую в столярную мастерскую.
            </p>
            <div rtElem="editorial-channels">
                <div>
                    <span rtElem="editorial-channel-label" i18n="@@homeContactChannelEmail">Email</span>
                    <a href="mailto:staircraftdesigne@gmail.com">staircraftdesigne&#64;gmail.com</a>
                </div>
            </div>
        </div>
    }

    <div rtElem="form-wrap">
        <div rtElem="live-region" role="status" aria-live="polite">{{ liveStatus() }}</div>

        <form rtElem="form" novalidate ngNoForm (submit)="onSubmit($event)">
            <rt-field rtElem="field" i18n-label="@@homeContactLabelName" label="Имя*" [hideRequiredMark]="true" [errors]="nameErrors">
                <rt-input
                    qa-dataid="contact-name"
                    autocomplete="name"
                    placeholder="Иван Петров"
                    i18n-placeholder="@@homeContactPlaceholderName"
                    [clearable]="false"
                    [formField]="form.name" />
            </rt-field>

            <rt-field rtElem="field" i18n-label="@@homeContactLabelTopic" label="Тема*" [hideRequiredMark]="true">
                <rt-select [options]="topicOptions" [clearable]="false" [formField]="form.topic" />
            </rt-field>

            <rt-field rtElem="field" i18n-label="@@homeContactLabelEmail" label="Email*" [hideRequiredMark]="true" [errors]="emailErrors">
                <rt-input
                    type="email"
                    autocomplete="email"
                    placeholder="you@example.com"
                    i18n-placeholder="@@homeContactPlaceholderEmail"
                    [clearable]="false"
                    [formField]="form.email" />
            </rt-field>

            <rt-field rtElem="field" i18n-label="@@homeContactLabelPhone" label="Телефон">
                <rt-input
                    autocomplete="tel"
                    placeholder="+375 29 …"
                    i18n-placeholder="@@homeContactPlaceholderPhone"
                    [clearable]="false"
                    [formField]="form.phone" />
            </rt-field>

            <rt-field
                rtElem="field"
                i18n-label="@@homeContactLabelMessage"
                label="Сообщение*"
                [rtMod]="{ full: true }"
                [hideRequiredMark]="true"
                [errors]="messageErrors">
                <rt-textarea
                    resize="vertical"
                    placeholder="Опишите помещение, ожидания и сроки."
                    i18n-placeholder="@@homeContactPlaceholderMessage"
                    [rows]="4"
                    [formField]="form.message" />
                <span rtElem="counter">{{ messageLength() }} / 2000</span>
            </rt-field>

            <div rtElem="consent">
                <rt-checkbox rtElem="checkbox" [formField]="form.consent">
                    <span rtElem="checkbox-label">
                        <span i18n="@@homeContactConsentA">Соглашаюсь с обработкой персональных данных согласно</span>
                        &ngsp;
                        <a routerLink="/privacy" i18n="@@homeContactConsentLink">политике конфиденциальности</a>
                        <span i18n="@@homeContactConsentB">. Данные используются только для ответа на запрос.</span>
                    </span>
                </rt-checkbox>
            </div>

            <div rtElem="captcha-row">
                <div rtElem="captcha-head">
                    <div rtElem="captcha-text">
                        <span rtElem="captcha-title" i18n="@@homeContactCaptchaTitle">Подтвердите, что вы человек</span>
                        @if (captchaFallback()) {
                            <span rtElem="captcha-sub" i18n="@@homeContactCaptchaFallbackSub">
                                проверка cf-turnstile недоступна — отметьте вручную
                            </span>
                        } @else {
                            <span rtElem="captcha-sub" i18n="@@homeContactCaptchaSub">невидимая проверка · cf-turnstile</span>
                        }
                    </div>
                    <div rtElem="captcha-brand" aria-hidden="true">
                        <span>CLOUDFLARE</span>
                        <b>TURNSTILE</b>
                    </div>
                </div>
                @if (captchaFallback()) {
                    <rt-checkbox
                        rtElem="checkbox"
                        [rtMod]="{ captcha: true }"
                        [disabled]="isBusy()"
                        [ngModel]="model().captchaToken.length > 0"
                        (ngModelChange)="onFallbackCaptchaToggle($event)">
                        <span rtElem="checkbox-label" i18n="@@homeContactCaptchaFallbackLabel">Я не робот</span>
                    </rt-checkbox>
                }
                <div
                    #captchaContainer
                    rtElem="captcha"
                    role="group"
                    aria-label="Cloudflare Turnstile"
                    i18n-aria-label="@@homeContactCaptchaLabel"
                    [hidden]="captchaFallback()"></div>
            </div>

            <input
                rtElem="honeypot"
                type="text"
                name="company"
                tabindex="-1"
                autocomplete="off"
                aria-hidden="true"
                [value]="model().honeypot"
                (input)="onHoneypotInput($any($event.target).value)" />

            <div rtElem="submit-row">
                <div rtElem="status-line" [rtMod]="{ ok: status() === ContactSubmissionStatus.Success }">
                    @switch (status()) {
                        @case (ContactSubmissionStatus.Submitting) {
                            <span i18n="@@homeContactStatusSendingShort">— Отправляем…</span>
                        }
                        @case (ContactSubmissionStatus.Success) {
                            <span i18n="@@homeContactStatusSentShort">— Отправлено. Ответим в течение 24 часов.</span>
                        }
                        @case (ContactSubmissionStatus.Error) {
                            <span>— {{ errorMessage() }}</span>
                        }
                        @default {
                            @if (model().captchaToken.length === 0) {
                                <span i18n="@@homeContactStatusNeedCaptcha">— Подтвердите, что вы человек.</span>
                            } @else if (form().invalid()) {
                                <span i18n="@@homeContactStatusNeedFields">— Заполните обязательные поля.</span>
                            } @else if (!model().consent) {
                                <span i18n="@@homeContactStatusNeedConsent">— Подтвердите согласие на обработку данных.</span>
                            } @else if (!submitDisabled()) {
                                <span i18n="@@homeContactStatusReady">— Готово к отправке.</span>
                            }
                        }
                    }
                </div>
                <button rtElem="submit" rtButton type="submit" [disabled]="submitDisabled()">
                    @if (status() === ContactSubmissionStatus.Submitting) {
                        <span i18n="@@homeContactSubmitSending">Отправка…</span>
                    } @else {
                        <span i18n="@@homeContactSubmit">Отправить запрос</span>
                        <span aria-hidden="true">→</span>
                    }
                </button>
            </div>
        </form>
    </div>
</ng-container>
